import useSnackbar from "src/store/useSnackbar";
import { shallow } from "zustand/shallow";
import { calculateDiscountAmount, calculateDiscountedAmount } from "..";
import useCheckoutStore from "../../../store/checkout.store";
const useCoupon = ()=>{
    const { addSnackbar  } = useSnackbar();
    const { deliveryFeeCouponAmount , removeProductCoupon , applyProductCoupon , orderItems , userCoupons , updateUsedCash , updateUsedPoint  } = useCheckoutStore((state)=>({
            deliveryFeeCouponAmount: state.deliveryInfo.deliveryFeeCouponAmount,
            removeProductCoupon: state.removeProductCoupon,
            applyProductCoupon: state.applyProductCoupon,
            orderItems: state.orderItems,
            userCoupons: state.userCoupons,
            updateUsedCash: state.updateUsedCash,
            updateUsedPoint: state.updateUsedPoint
        }), shallow);
    var _orderItems_some;
    const appliedMaxCoupon = (_orderItems_some = orderItems === null || orderItems === void 0 ? void 0 : orderItems.some((item)=>item.isCouponApplied)) !== null && _orderItems_some !== void 0 ? _orderItems_some : false;
    // 사용가능한 쿠폰리스트에 해당되는지 확인
    const checkAvailableCouponList = (id)=>{
        return userCoupons.filter((coupon)=>coupon.usableProductIds.includes(id));
    };
    const hasCoupon = deliveryFeeCouponAmount > 0 || !!(orderItems === null || orderItems === void 0 ? void 0 : orderItems.find((item)=>item.isCouponApplied));
    // 캐시/포인트 사용 금액 리셋
    const resetCashAndPoint = ()=>{
        updateUsedCash(0);
        updateUsedPoint(0);
    };
    const applyCoupon = (currentItem, coupon)=>{
        // 적용안함인 경우
        if (coupon === null) {
            removeProductCoupon(currentItem.id);
            return;
        }
        // 쿠폰 적용 최소 금액 검증
        if (coupon.minimumPrice && currentItem.price < coupon.minimumPrice) {
            addSnackbar({
                message: "적용실패 (최소 사용금액 조건 미달)",
                variant: "error"
            });
            return;
        }
        // 다른 상품에 동일한 쿠폰이 적용되어 있으면 먼저 해제 (재계산은 applyProductCoupon에서 수행)
        const itemWithSameCoupon = orderItems === null || orderItems === void 0 ? void 0 : orderItems.find((item)=>item.appliedCouponId === coupon.id && item.id !== currentItem.id);
        if (itemWithSameCoupon) {
            removeProductCoupon(itemWithSameCoupon.id, true);
        }
        const discountAmount = calculateDiscountAmount({
            discountType: coupon.discountType,
            discountValue: coupon.discountValue,
            price: currentItem.price,
            discountMaximumPrice: coupon.discountMaximumPrice
        });
        const discountedPrice = parseInt(calculateDiscountedAmount({
            price: currentItem.price,
            discount: discountAmount
        }));
        applyProductCoupon(currentItem.id, coupon.id, discountedPrice);
        // 쿠폰 적용 후 캐시/포인트 리셋
        resetCashAndPoint();
    };
    return {
        orderItems,
        hasCoupon,
        applyCoupon,
        checkAvailableCouponList,
        appliedMaxCoupon
    };
};
export default useCoupon;
